import { render } from "./ModelPerformanceMonitoring.vue?vue&type=template&id=39ca4c1e&scoped=true"
import script from "./ModelPerformanceMonitoring.vue?vue&type=script&lang=js"
export * from "./ModelPerformanceMonitoring.vue?vue&type=script&lang=js"

import "./ModelPerformanceMonitoring.vue?vue&type=style&index=0&id=39ca4c1e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ca4c1e"]])

export default __exports__